module.exports = __webpack_public_path__ + "static/media/noticias-bg.bfb6f20e.png";